import { render, staticRenderFns } from "./TurnPanel.vue?vue&type=template&id=ea601164&scoped=true&"
import script from "./TurnPanel.vue?vue&type=script&lang=js&"
export * from "./TurnPanel.vue?vue&type=script&lang=js&"
import style0 from "./TurnPanel.vue?vue&type=style&index=0&id=ea601164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea601164",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VList } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCard,VCardActions,VList,VSubheader})
